import React, { useState } from "react";
import Images from "../../Component/Simage";

function PinningNfts() {
  const [nfts, setNfts] = useState([
    {
      id: 1,
      value: "Audio",
      img: Images.audio,
    },
    {
      id: 2,
      value: "Video",
      img: Images.video,
    },
    {
      id: 3,
      value: "Image",
      img: Images.image,
    },
    {
      id: 4,
      value: "Text",
      img: Images.text,
    },
    {
      id: 5,
      value: "Files",
      img: Images.files,
    },
  ]);

  return (
    <div className="nfts">
      <div className="container ai-container">
        <h1 className="title-txt text-center fw-700 mb-3 mb-xxl-4">
          Pinning your NTFS
        </h1>
        <div className="ntfs_content">
          {nfts?.map((item, index) => {
            return (
              <div className="item" key={item.id}>
                <img src={item.img} className="img-fluid img_src" />
                <p className="mb-0 value 700">{item.value}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PinningNfts;
